import React, { Component } from 'react';
import { Row, Col, Collapse, Container } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import classname from 'classnames';

//i18n
import { withNamespaces } from 'react-i18next';

import { connect } from 'react-redux';

let authUser, bankAdmin;

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidUpdate(prevProps) {
    authUser = await JSON.parse(localStorage.getItem("authUser"));
    bankAdmin = await JSON.parse(localStorage.getItem("bankAdmin"))
    if (prevProps !== this.props) {
      this.setState({});
    }
  }

  componentDidMount() {
    var matchingMenuItem = null;
    var ul = document.getElementById('navigation');
    var items = ul.getElementsByTagName('a');
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add('active');
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add('active'); // li
      const parent2 = parent.parentElement;
      parent2.classList.add('active'); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add('active'); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add('active'); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add('active'); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add('active'); // li
            }
          }
        }
      }
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        {!bankAdmin &&<div className='topnav'>
          <Container fluid>
            <nav
              className='navbar navbar-light navbar-expand-lg topnav-menu'
              id='navigation'
            >
              <Collapse
                isOpen={this.props.menuOpen}
                className='navbar-collapse'
                id='topnav-menu-content'
              >
                <ul className='navbar-nav'>
                  <li className='nav-item'>
                    <Link className='nav-link' to='/baythak'>
                      <i className='ri-dashboard-line mr-2'></i>{' '}
                      {this.props.t('Beythak')}
                    </Link>
                  </li>

                  <li className='nav-item dropdown'>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        // this.setState({ appState: !this.state.appState });
                      }}
                      className='nav-link dropdown-toggle arrow-none'
                      to='/#'
                      id='topnav-apps'
                      role='button'
                    >
                      <i className='ri-apps-2-line mr-2'></i>
                      {this.props.t('Users')} <div className='arrow-down'></div>
                    </Link>
                    <div
                      className={classname('dropdown-menu', {
                        show: this.state.appState,
                      })}
                      aria-labelledby='topnav-apps'
                    >
                      <Link to='/users/farmers' className='dropdown-item'>
                        {this.props.t('Farmers')}
                      </Link>
                      <Link to='/user-delete' className='dropdown-item'>
                        {this.props.t('User delete')}
                      </Link>

                      {authUser?.data?.userType !== "CCR" && (
                        <div>
                          <Link to='/users/buyers' className='dropdown-item'>
                            {this.props.t('Buyers')}
                          </Link>
                          <Link to='/users/advisors' className='dropdown-item'>
                            {this.props.t('Advisors')}
                          </Link>
                          <Link to='/users/ccr' className='dropdown-item'>
                            {this.props.t('Ccrs')}
                          </Link>
                        </div>
                      )}
                    </div>
                  </li>


                  {authUser?.data?.userType !== "CCR" && (
                    <li className='nav-item dropdown'>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          // this.setState({ appState: !this.state.appState });
                        }}
                        className='nav-link dropdown-toggle arrow-none'
                        to='/#'
                        id='topnav-apps'
                        role='button'
                      >
                        <i className='ri-apps-2-line mr-2'></i>
                        {this.props.t('Advisory')}{' '}
                        <div className='arrow-down'></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {
                          show: this.state.appState,
                        })}
                        aria-labelledby='topnav-apps'
                      >
                        <Link to='/advisory/sessions' className='dropdown-item'>
                          {this.props.t('Advisory Sessions')}
                        </Link>

                      </div>
                    </li>
                  )}
                  {authUser?.data?.userType !== "CCR" && (
                    <li className='nav-item'>
                      <Link className='nav-link' to='/mundi'>
                        <i className='ri-dashboard-line mr-2'></i>{' '}
                        {this.props.t('Marketplace - Mandi')}
                      </Link>
                    </li>
                  )}
                  {authUser?.data?.userType !== "CCR" && (
                    <li className='nav-item dropdown'>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({ extraState: !this.state.extraState });
                        }}
                        className='nav-link dropdown-toggle arrow-none'
                        to='/#'
                        id='topnav-more'
                        role='button'
                        data-toggle='dropdown'
                        aria-haspopup='true'
                        aria-expanded='false'
                      >
                        <i className='ri-file-copy-2-line mr-2'></i>
                        {this.props.t('Farm Supplies')}{' '}
                        <div className='arrow-down'></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {
                          show: this.state.extraState,
                        })}
                        aria-labelledby='topnav-more'
                      >
                        <div className='dropdown'>
                          <Link to='/supplies/orders' className='dropdown-item'>
                            {this.props.t('Orders')}
                          </Link>
                          <Link to='/supplies/products' className='dropdown-item'>
                            {this.props.t('Products')}
                          </Link>
                          <Link
                            to='/supplies/categories'
                            className='dropdown-item'
                          >
                            {this.props.t('Categories')}
                          </Link>
                          <Link
                            to='/supplies/companies'
                            className='dropdown-item'
                          >
                            {this.props.t('Companies')}
                          </Link>
                        </div>
                      </div>
                    </li>
                  )}
                  {authUser?.data?.userType !== "CCR" && (
                    <li className='nav-item dropdown'>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          // this.setState({ appState: !this.state.appState });
                        }}
                        className='nav-link dropdown-toggle arrow-none'
                        to='/#'
                        id='topnav-apps'
                        role='button'
                      >
                        <i className='ri-apps-2-line mr-2'></i>
                        {this.props.t('System')}{' '}
                        <div className='arrow-down'></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {
                          show: this.state.appState,
                        })}
                        aria-labelledby='topnav-apps'
                      >
                        <Link to='/system/languages' className='dropdown-item'>
                          {this.props.t('Languages')}
                        </Link>
                        <Link to='/system/raqbas' className='dropdown-item'>
                          {this.props.t(`Raqbas`)}
                        </Link>
                        <Link
                          to='/system/advisors-expertise'
                          className='dropdown-item'
                        >
                          {this.props.t(`Advisory Expertise`)}
                        </Link>
                        <Link
                          to='/system/advisory-stats'
                          className='dropdown-item'
                        >
                          {this.props.t(`Problem Categories`)}
                        </Link>
                        <Link to='/system/cities' className='dropdown-item'>
                          {this.props.t(`Cities`)}
                        </Link>
                        <Link to='/system/districts' className='dropdown-item'>
                          {this.props.t(`Districts`)}
                        </Link>
                        <Link to='/system/vegetables' className='dropdown-item'>
                          {this.props.t(`Crops`)}
                        </Link>
                      </div>
                    </li>
                  )}{(<li className='nav-item'>
                    <Link
                      className='nav-link'
                      to='/loan'
                    >
                      <i className='ri-bubble-chart-line mr-2'></i>
                      {this.props.t('Loan')}{' '}
                      {/* <div className='arrow-down'></div> */}
                    </Link></li>
                  )}
                  {(<li className='nav-item'>
                    <Link
                      className='nav-link'
                      to='/user-delete'
                    >
                      <i className='ri-bubble-chart-line mr-2'></i>
                      {this.props.t('UserDelete')}{' '}
                      {/* <div className='arrow-down'></div> */}
                    </Link></li>
                  )}

                </ul>
              </Collapse>
            </nav>
          </Container>
        </div>}
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { leftSideBarType, leftSideBarTheme } = state.Layout;
  return { leftSideBarType, leftSideBarTheme };
};

export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(Navbar))
);
